import React from 'react'
import { Button, Modal } from 'react-bootstrap'

const ProblemListModal = ({show, setShow, data}) => {

    const handleClose = () => setShow(false);

    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Problem List Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="d-flex align-items-between gap-3 justify-content-center">
                    <div className="avatar border border-2 border-success text-info d-flex justify-content-center align-items-center w-25 h-25 mt-5">
                        <i class="ri-capsule-fill fs-1"></i>
                    </div>
                    <div>
                        <h6 className="mb-0">
                            <label className=''>Consultant</label>
                            <p className='fs-sm text-success'>
                                {data?.createdBy?? "---"}
                            </p>
                        </h6>
                        <h6 className="mb-0">
                            <label className=''>Diagnosis</label>
                            <p className='fs-sm text-danger'>
                                {data?.diagnosis?.description?? "---"}
                            </p>
                        </h6>
                        <h6 className="mb-0">
                            <label className=''>Type</label>
                            <p className='fs-sm text-uppercase'>
                                {data?.diagnosis?.type?? "---"}
                            </p>
                        </h6>
                        <h6 className="mb-0">
                            <span className=''>Comment</span>
                            <p className='fs-sm'>
                                {data?.comment?? "---"}
                            </p>
                        </h6>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                {/* <Button variant="primary" onClick={handleClose}>
                    Yes! Verify
                </Button>
                */}
                <Button variant="secondary" onClick={handleClose}>
                    Close
                </Button> 
            </Modal.Footer>
        </Modal>
    )
}

export default ProblemListModal
